import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/home',
    iconComponent: { name: 'cil-speedometer' },
    badge: {
      color: 'info',
      text: 'NEW'
    }
  },
  {
    title: true,
    name: 'Configuración'
  },
  {
    name: 'Configuración General',
    url: '/dashboard/configuracion/',
    iconComponent: { name: 'cil-settings' }
  },
  {
    name: 'Usuarios',
    url: '/dashboard/usuarios/lista',
    iconComponent: { name: 'cil-user' }
  },
  {
    name: 'Perfiles',
    url: '/dashboard/nominados/lista',
    iconComponent: { name: 'cil-pencil' }
  },
  {
    name: 'Contactos',
    url: '/dashboard/contactos',
    iconComponent: { name: 'cil-people' }
  },
  {
    name: 'Votos',
    url: '/dashboard/registros/votos',
    iconComponent: { name: 'cil-notes' }
  },
  {
    title: true,
    name: 'Paginas Editables'
  },
  {
    name: 'Home',
    url: '/',
    iconComponent: { name: 'cil-pencil' }
  }, {
    name: 'Sobre el Galardon',
    url: '/sobre-el-galardon',
    iconComponent: { name: 'cil-pencil' }
  },
  {
    name: 'Preguntas Frecuentes',
    url: '/preguntas-frecuentes',
    iconComponent: { name: 'cil-pencil' }
  },
  {
    name: 'Contacto',
    url: '/contacto',
    iconComponent: { name: 'cil-pencil' }
  },
  {
    name: 'Terminos',
    url: '/terminos',
    iconComponent: { name: 'cil-pencil' }
  },
  {
    name: 'Politicas',
    url: '/politicas',
    iconComponent: { name: 'cil-pencil' }
  }
];
